/** Keep a product analysis linked to its later chat turns, including after reload. */
export function getProductAnalysisContext(messages, question) {
  const text = String(question || '').trim().toLowerCase();
  if (!text) return null;
  const recent = messages || [];

  for (let i = recent.length - 1; i >= Math.max(0, recent.length - 16); i -= 1) {
    const message = recent[i];
    if (message?.sender === 'user' && message.productAnalysisProductId && message.productAnalysisProduct) {
      const product = message.productAnalysisProduct;
      const name = product.name || '';
      const brand = product.brand || '';
      const namesProduct = (name && text.includes(name.toLowerCase())) || (brand && text.includes(brand.toLowerCase()));
      const refersToProduct = /\b(this|that|it|these|those)\b|^check\s+(the\s+|your\s+)?(ingredients|formula|database)\b|^what\s+about\b/i.test(text);
      if (namesProduct || refersToProduct) {
        return { productId: message.productAnalysisProductId, product: { name, brand },
          excerpt: `Product: ${name} by ${brand}.` };
      }
      return null;
    }
    const card = message?.sender === 'assistant' ? message.text : null;
    if (!card || (card.type !== 'product_followup' && card.type !== 'product_analysis')) continue;

    const product = card.type === 'product_followup' ? card.product || {} : card.data || {};
    const name = product.name || card.productName || '';
    const brand = product.brand || card.productBrand || '';
    const productId = product.catalogProductId || product.catalog_product_id || null;
    const namesProduct = (name && text.includes(name.toLowerCase())) || (brand && text.includes(brand.toLowerCase()));
    const refersToProduct = /\b(this|that|it|these|those)\b|^check\s+(the\s+|your\s+)?(ingredients|formula|database)\b|^what\s+about\b/i.test(text);
    if (!namesProduct && !refersToProduct) return null;

    const score = card.matchScore ?? product.score;
    const reasoning = card.recommendation?.reasoning || product.reasoning || '';
    const ingredients = Array.isArray(product.keyIngredients) ? product.keyIngredients
      : Array.isArray(product.key_ingredients) ? product.key_ingredients : [];
    const concerns = card.analysis?.cons || product.concerns || [];
    const excerpt = [
      `Product: ${name} by ${brand}.`,
      score != null && `Match score: ${score}%.`,
      reasoning && `Summary: ${String(reasoning).slice(0, 480)}`,
      ingredients.length && `Selected ingredients: ${ingredients.join(', ').slice(0, 180)}`,
      concerns.length && `Assessment caution: ${String(concerns[0]).slice(0, 240)}`,
    ].filter(Boolean).join(' ');

    return { productId, product: { name, brand }, excerpt };
  }
  return null;
}
